import { Component } from '@angular/core';
import { CandidateService } from '../../services/candidate.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CandidateModalComponent } from '../candidate/candidate-modal/candidate-modal.component';
import { HttpClient } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { PortalAdminService } from 'src/app/services/portal-admin.service';
import { retry, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { IClientSearch } from 'src/types/client/clients';
@Component({
  selector: 'app-client-search',
  templateUrl: './client-search.component.html',
  styleUrls: ['./client-search.component.css']
})
export class ClientSearchComponent {
  userId: any;
  public model: any;
  clients: IClientSearch[] = [];
  pageSizeOptions = [10, 20, 50, 100];
  page: any = 1;
  pageSize: any = 10;
  collectionSize = 10;
  loading: boolean = true;
  selected: string = 'client-search';
  candidateId!: string;
  errorMessage : string = '';
  isPortalAdmin!:boolean;
  clientId!: any;
  clientCorporation:any;
  clientName:string=''
  
  constructor(
    private clientService:CandidateService ,private http:HttpClient,private authService: MsalService,
    private modalService: NgbModal, private portalAdminService:PortalAdminService
  ) {}

  ngOnInit(): void {  
  }

  public openViewModel = (id: any, name:any,clientCorporation:any) => {
    this.clientId=id;
    this.clientName=name,
    this.clientCorporation=clientCorporation;
    const client = this.clients.find(c => c.id === id);
    const modalRef = this.modalService.open(CandidateModalComponent, {
      size: 'xl',
      backdrop: 'static',
    });

    modalRef.result
      .then((result) => {
        this.loading = true;
        this.clientService
          .getClients(this.page.toString(), "", this.pageSize)
          .subscribe((response: any) => {
            this.clients = response.data;
            this.collectionSize = response.extraParam.totalCount;
            this.errorMessage = '';
            this.loading = false;
          });
      })
      .catch((error) => {
        console.error(error);
      });

    // Pass additional parameters to modal
    modalRef.componentInstance.clientCorporation=this.clientCorporation;
    modalRef.componentInstance.candidateName=this.clientName;
    modalRef.componentInstance.clientID = id;
    modalRef.componentInstance.clientEmail = client ? client.email : '';
    modalRef.componentInstance.isPortalAdmin = this.isPortalAdmin;
    modalRef.componentInstance.modalType = 'client'; // Add this to distinguish between client and candidate
  };

  public refreshClients = (
    page: string = '1',
    query: string = '',
    pageSize: string = '10'
  ) => {
    this.errorMessage='';
    this.loading = true;
    this.page = page;
    this.pageSize = pageSize;
    this.clients = [];
    this.clientService
      .getClients(this.page.toString(), query, this.pageSize)
      .pipe(
        retry(1), // Will retry failed request once before failing
        catchError(error => {
          this.loading = false;
          this.errorMessage = 'Oops, something went wrong while fetching clients. Please try again later.';
          return of(null); // Return an empty observable to prevent the error from propagating
        })
      ).subscribe((response: any) => {
        this.clients = response.data;
        this.collectionSize = response.extraParam.totalCount;
        this.errorMessage='';
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.errorMessage = 'Oops, something went wrong while fetching clients. Please try again later.';
      });
  };
}

